import styled from 'styled-components';

import themeColors from '@polyai/ui/styles/config/colors';

export const ResetButton = styled.button`
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: start;

  width: 32px;
  height: 32px;
  padding: 0;

  color: ${themeColors.textSecondary};

  background: ${themeColors.background};
  border: 1px solid ${themeColors.borderSubtle};
  border-radius: 50%;

  transition: background-color 0.2s ease, border-color 0.2s ease,
    color 0.2s ease, transform 0.2s ease;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }

  &:hover:not(:disabled) {
    color: ${themeColors.textPrimary};
    background: ${themeColors.backgroundHover};
    border-color: ${themeColors.borderStrong};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
